function normalizeVector(v){
    let l = Math.sqrt((v.x * v.x) + (v.y * v.y));
    if(l == 0) return {x: 0, y: 0};
    return {x: v.x/l, y: v.y/l};
}

function rotateVector(vec, ang)
{
    return {
        x: vec.x * Math.cos(ang) - vec.y * Math.sin(ang),
        y: vec.x * Math.sin(ang) + vec.y * Math.cos(ang)
    }
};

export {normalizeVector, rotateVector}
